/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Virtual Key Definitions (@accedo/xdk-virtual-key) 4.1.1
* 
*******************************************************************************/
import _forEachInstanceProperty from"@babel/runtime-corejs3/core-js-stable/instance/for-each";import _Map from"@babel/runtime-corejs3/core-js-stable/map";import addVKey from"./addVKey";const addVKeys=(e,a)=>{var r;_forEachInstanceProperty(r=new _Map(a)).call(r,((a,r)=>addVKey(e,r,a)))};export default addVKeys;